import React, { useEffect } from "react";
import homeaboutimg from '../assets/images/homeaboutimg.webp';
import alumniicon1 from '../assets/images/alumniicon1.webp';
import alumniicon2 from '../assets/images/alumniicon2.webp';
import alumniicon3 from '../assets/images/alumniicon3.webp';
import AOS from "aos";
import 'aos/dist/aos.css';
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
// import required modules
import {Autoplay, Pagination } from 'swiper/modules';

const Home = () => {
    const pagination = {
        clickable: true,
      };
      
    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, [])
    return (
      <div>
        <Swiper
          loop={true}
          pagination={pagination}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, Pagination]}
          className="mySwiper"
        >
          <SwiperSlide>
            <section className="home-main-section">
              <div className="home-main-content-secion text-center">
                <p className="home-main-head">Register as a Member</p>
                <p className="home-main-para">
                  Join our vibrant community of SVU Zoology alumni dedicated to
                  fostering lifelong connections,
                  <br />
                  advancing zoological sciences, and supporting the next
                  generation.{" "}
                </p>

                <div className="register-btn">
                  <Link to="/" className="know-more-btn-text">
                    Register Now
                  </Link>
                </div>
              </div>
            </section>
          </SwiperSlide>
          <SwiperSlide>
            <section className="home-main-section">
              <div className="home-main-content-secion text-center">
                <p className="home-main-head">Welcome to SVU Zoology Alumni Association</p>
                <p className="home-main-para">
                Join our vibrant community of SVU Zoology alumni dedicated to fostering lifelong connections,<br /> advancing zoological sciences, and supporting the next generation. 
                </p>

                <div className="register-btn">
                  <Link to="/" className="know-more-btn-text">
                    Know More
                  </Link>
                </div>
              </div>
            </section>
          </SwiperSlide>
        </Swiper>

        <section className="home-about-section">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-6 order-2 order-lg-1">
                <div className="home-about-left-sec">
                  <img src={homeaboutimg} className="home-about-img" />
                </div>
              </div>
              <div className="col-12 col-lg-6 order-1 order-lg-2">
                <div className="home-about-right-sec">
                  <p
                    className="home-about-btn"
                    data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-duration="300"
                  >
                    about us
                  </p>
                  <p
                    className="home-about-head"
                    data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-duration="300"
                  >
                    Welcome to SVU Zoology Alumni Association
                  </p>

                  <p
                    className="home-about-para"
                    data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-duration="300"
                  >
                    The SVU Zoology Department Alumni Association unites a
                    diverse and accomplished network of graduates who have
                    excelled in academia, research, and various industries
                    worldwide. Our alumni have made significant contributions to
                    life sciences, both in India and abroad, holding esteemed
                    positions in research organizations, universities, and the
                    corporate world.
                  </p>

                  <div
                    className="know-more-btn"
                    data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-duration="300"
                  >
                    <Link to="/" className="know-more-btn-text">
                      Know More
                    </Link>
                    <i
                      class="fa fa-long-arrow-right    more-icon"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="home-alumni-link-section">
          <div className="container">
            <p className="home-about-btn">Alumni Association links</p>
            <p className="home-about-head alumuni-link-color">
              SVU Zoology Alumni Association Links
            </p>
            <div className="row">
              <div className="col-12 col-md-6 col-lg-4 mb-2 mb-md-4">
                <div
                  className="alumni-link-box text-center"
                  data-aos="fade-up"
                  data-aos-delay="300"
                  data-aos-duration="300"
                >
                  <img src={alumniicon1} className="alumni-icon-img" />
                  <p className="alumni-link-head">Alumni Commitee</p>
                  <p className="alumni-link-para">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
                    elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus
                    leo.
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-2 mb-md-4">
                <div
                  className="alumni-link-box text-center"
                  data-aos="fade-up"
                  data-aos-delay="300"
                  data-aos-duration="600"
                >
                  <img src={alumniicon2} className="alumni-icon-img" />
                  <p className="alumni-link-head">Alumni Registration</p>
                  <p className="alumni-link-para">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
                    elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus
                    leo.
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-2 mb-md-4">
                <div
                  className="alumni-link-box  text-center"
                  data-aos="fade-up"
                  data-aos-delay="300"
                  data-aos-duration="900"
                >
                  <img src={alumniicon3} className="alumni-icon-img" />
                  <p className="alumni-link-head">Alumni Course Wise</p>
                  <p className="alumni-link-para">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
                    elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus
                    leo.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="home-work-section">
          <div className="container">
            <p className="home-about-btn">How It Works</p>
            <p className="home-about-head work-head-home ">
              How to Register with SVUZAA
            </p>
            <div className="row   homw-work-sec-box-row">
              <div className="col-12 col-md-6 col-lg-4 ">
                <div
                  className="home-work-section-box"
                  data-aos="fade-up"
                  data-aos-delay="300"
                  data-aos-duration="300"
                >
                  <div class="flip-card">
                    <div class="flip-card-inner">
                      <div class="flip-card-front home-work-section-innerbox text-center">
                        <i
                          class="fa fa-mouse-pointer    home-work-flipicon"
                          aria-hidden="true"
                        ></i>
                        <p className="almini-work-head">
                          Go to Alumni Registration Page
                        </p>
                      </div>
                      <div class="flip-card-back">
                        <p className="almini-work-head">
                          Go to Alumni Registration Page
                        </p>
                        <p className="flip-card-click-btn">Click Here</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-4 ">
                <div
                  className="home-work-section-box"
                  data-aos="fade-up"
                  data-aos-delay="300"
                  data-aos-duration="600"
                >
                  <div class="flip-card">
                    <div class="flip-card-inner">
                      <div class="flip-card-front home-work-section-innerbox text-center home-work-section-innerboxyellow">
                        <i
                          class="fa fa-pencil-square-o   home-work-flipicon"
                          aria-hidden="true"
                        ></i>
                        <p className="almini-work-head">
                          Fill & Submit Your Details
                        </p>
                      </div>
                      <div class="flip-card-back">
                        <p className="almini-work-head">
                          Fill & Submit Your Details
                        </p>
                        <p className="flip-card-click-btn">Click Here</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-4 ">
                <div
                  className="home-work-section-box"
                  data-aos="fade-up"
                  data-aos-delay="300"
                  data-aos-duration="900"
                >
                  <div class="flip-card">
                    <div class="flip-card-inner">
                      <div class="flip-card-front home-work-section-innerbox text-center ">
                        <i
                          class="fa fa-users   home-work-flipicon"
                          aria-hidden="true"
                        ></i>
                        <p className="almini-work-head">
                          You will be registered with the respective Batch
                        </p>
                      </div>
                      <div class="flip-card-back text-center">
                        <p className="almini-work-head">
                          You will be registered with the respective Batch
                        </p>
                        <p className="flip-card-click-btn">Click Here</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
}

export default Home;